module.exports = __webpack_public_path__ + "img/cn-bg-animate.68b1469.png";